module.exports = __webpack_public_path__ + "133a93b173d502683dc50e975a9a6004.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/toolbar/undo.svg
// module id = 32
// module chunks = 0